module.exports = __webpack_public_path__ + "static/gallery2-c613e3247e0dbf8c6d05c4b0df69e55b.png";